export const ONE_WAY = 'ONEWAY';
export const RETURN_TRIP = 'RETURNTRIP';

export const STORAGE_KEY = {
  LOCALE: 'LOCALE',
  USER: 'USER',
  CONFIG: 'CONFIG',
  RAW_CONTRACT: 'RAW_CONTRACT',
  SEARCH_DATA: 'SEARCH_DATA',
  RECAP_DATA: 'RECAP_DATA',
  VEHICLE_ID: 'VEHICLE_ID',
  ORDER_CODE: 'ORDER_CODE',
  SSO_TOKEN: 'SSO_TOKEN',
  SSO_REFRESH_TOKEN: 'SSO_REFRESH_TOKEN',
  AUTH_TOKEN: 'AUTH_TOKEN',
  AUTH_REFRESH_TOKEN: 'AUTH_REFRESH_TOKEN',
  LOGIN_PENDING: 'LOGIN_PENDING',
  REGISTER_LOGIN_SENT: 'REGISTER_LOGIN_SENT',
  LOGOUT_PENDING: 'LOGOUT_PENDING',
  KEYCLOAK_CONFIG: 'KEYCLOAK_CONFIG',
  IMPERSONATE: 'IMPERSONATE',
  COMPANY_CONFIG: 'COMPANY_CONFIG',
  SEARCH_HISTORY: 'SEARCH_HISTORY',
  BOOKING_WORLDPAY: 'BOOKING_WORLDPAY',
  GDPR_NOTICE_DISMISSAL: 'GDPR_NOTICE_DISMISSAL'
};

export const STORAGE_ENUM = {
  BAD_ORDER_CODE: 'BOC',
  TOKEN_TYPE: {
    NORMAL: 'NOR',
    SSO: 'SSO'
  }
};

// Where GET /v2/members/me stands. It is the /me counterpart of KEYCLOAK_STATUS
// (utils/keycloak.js), and it draws the same distinction that one draws between
// `null` and UNAUTH: IDLE is not "no member", it is "nobody has asked yet", which
// happens whenever kc.init() reports a session but the app never calls /me.
// The four answers are kept apart rather than folded into one "answered" because a
// caller that acts on them cannot treat them alike: REFUSED is a verdict on the
// account, FAILED is only the absence of one, and ending a Keycloak session is
// right for the first and destructive for the second.
// It lives here rather than next to KEYCLOAK_STATUS because reducers/keycloak.js
// needs it while building its default state, and this module imports nothing -
// utils/keycloak.js sits inside the utils -> store -> reducers import cycle.
export const VERIFY_STATUS = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  // 2xx - the member exists
  MEMBER: 'MEMBER',
  // 404 - a Keycloak session with no member behind it yet, i.e. the one failure the
  // app carries on from: it is where registration begins
  NO_MEMBER: 'NO_MEMBER',
  // 401/403/422 - the backend knows the account and will not serve it: verification
  // failed, not activated, being anonymized
  REFUSED: 'REFUSED',
  // anything else - 5xx, a gateway timeout, a connection that dropped (that one
  // arrives with no HTTP status at all). The backend did not answer for the account,
  // which says nothing about the account
  FAILED: 'FAILED'
};

export const NUMBER_FORMAT = {
  E164: 'E164',
  INTERNATIONAL: 'INTERNATIONAL',
  NATIONAL: 'NATIONAL',
  RFC3966: 'RFC3966'
};

export const FLASH_MESSAGE_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  BUG: 'bug',
  DISABLED: 'disabled'
};

export const LEGACY_SUBSCRIBE = 'subscribe';

export const PRE_BOOKING_TYPE = {
  TEST_DRIVE: 'TD',
  REPLACEMENT_VEHICLE: 'RV',
  PUBLIC_SERVICE: 'PS'
};

export const TEST_DRIVE_STRING = 'Test drive';

export const ADD_TO_CALENDAR = {
  DATE_FORMAT: 'YYYY-MM-DD',
  TIME_FORMAT: 'HH:mm',
  OPTIONS: [
    'Apple',
    'Google',
    'iCal',
    'Microsoft365',
    'MicrosoftTeams',
    'Outlook.com',
    'Yahoo'
  ]
};
